import BaseModelAPI from '../BaseModelAPI';

export default class PostingSupplyForProductionList extends BaseModelAPI {

	static entity = 'postingsupplyforproductionlist'
	static entityName = 'postingsupplyforproduction';

	constructor() {
		this.pageIndex = 0;
		this.pageSize = 0;
		this.pageCount = 0;
		this.dataCount = 0;
	}
}
